import React from 'react';
import SessionEndedDialog from '../dialogs/SessionEndedDialog';
import ErrorDialog from '../dialogs/ErrorDialog';
import { ApiError } from '../hooks/useAuthenticatedFetch';

// todo use routing to handle errors globally

const GlobalErrorFallback = ({ error }) => {
  let message = error.message;

  if (error instanceof ApiError) {
    const { status, data } = error;
    message = data.message || message;
    console.error(`API error ${status}: ${message}`);

    if (status === 403) {
      const { reason } = data;
      if (reason === 'session') return <SessionEndedDialog />;
      else return <ErrorDialog message={message} />;
    }

    if (status === 500) {
      message = 'An error occurred. If the problem persists please contact support.';
    }
  }

  return (
    <ErrorDialog message={message} />
  );
};

export default GlobalErrorFallback;